import Vue from 'vue'
import Router from 'vue-router'
import Welcome from '@/components/Welcome'
import TournamentsOverview from '@/components/TournamentsOverview'
import Bracket from '@/components/Bracket'
import TournamentPage from '@/components/TournamentPage'
import TeamPage from '@/components/TeamPage'
import TeamsOverview from '@/components/TeamsOverview'
import Login from '@/components/Login'
import Signup from '@/components/Signup'
import TeamComparison from '@/components/TeamComparison'
import firebase from 'firebase';


Vue.use(Router)

let router = new Router({
  routes: [
    {
      path: '/',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/signup',
      name: 'Signup',
      component: Signup,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        requiresGuest: true
      }
    },
    {
      path: '/tournamentsOverview',
      name: 'TournamentsOverview',
      component: TournamentsOverview,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/teamsOverview',
      name: 'TeamsOverview',
      component: TeamsOverview,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tournament/:tournamentId',
      name: 'TournamentPage',
      component: TournamentPage,
      meta: {
        requiresAuth: true
      }
    },

    {
      path: '/team/:teamId',
      name: 'TeamPage',
      component: TeamPage,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tournament/:tournamentId/bracket',
      name: 'Bracket',
      component: Bracket,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/tournament/:tournamentId/bracket/:team1Id/vs/:team2Id',
      name: 'TeamComparison',
      component: TeamComparison,
      meta: {
        requiresAuth: true
      }
    }
  ]
})


// Guards
router.beforeEach((to,from,next) => {
  //Check for requiredAuth guard
  if(to.matched.some(record => record.meta.requiresAuth)){
    // Check if NOT logged in
    if(!firebase.auth().currentUser){
      // Go to login
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    }else{
      // Proceed to route
      next();
    }
  }else if(to.matched.some(record => record.meta.requiresGuest)){
    // Check if logged in
    if(firebase.auth().currentUser){
      next({
        path: '/tournamentsOverview',
        query: {
          redirect: to.fullPath
        }
      });
    }else{
      // Proceed to route
      next();
    }
  }else{
    // Proceed to route
    next();
  }
});

export default router;


// WEBPACK FOOTER //
// ./src/router.js